// JOBE-0044.10: DateValuePopover — three quick-pick buttons, a custom
// date input, and a relative-date shortcut palette per JOBE-0098.2's
// RELATIVE_DATE_TOKENS.

import { useEffect, useRef, useState } from 'react';
import { RELATIVE_DATE_TOKENS } from '../../../lib/omni-parser/vocabulary.js';

const QUICK_PICKS = [
  { label: 'Today', token: 'today' },
  { label: 'Last 7 days', token: 'last-7d' },
  { label: 'Last 30 days', token: 'last-30d' },
];

export function DateValuePopover({
  initialValues = [],
  onSubmit,
  onCancel,
}) {
  const [iso, setIso] = useState(() => {
    const v = initialValues[0];
    if (!v) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
    return '';
  });
  const isoRef = useRef(null);

  useEffect(() => {
    isoRef.current?.focus();
  }, []);

  const onKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      if (onCancel) onCancel();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      submitIso();
    }
  };

  const emit = (token) => {
    if (!token) return;
    if (onSubmit) onSubmit([token]);
  };

  const submitIso = () => {
    if (!iso) return;
    emit(iso);
  };

  return (
    <div
      className="library-composer-popover library-composer-date"
      role="dialog"
      aria-label="Pick a date"
      onKeyDown={onKeyDown}
    >
      <div className="library-composer-popover-body">
        <div className="library-composer-date-quickpicks" role="group" aria-label="Quick picks">
          {QUICK_PICKS.map((q) => (
            <button
              key={q.token}
              type="button"
              className="library-composer-date-quickpick"
              onClick={() => emit(q.token)}
            >
              {q.label}
            </button>
          ))}
        </div>
        <div className="library-composer-date-custom">
          <label className="library-composer-date-custom-label">
            Custom date
            <input
              ref={isoRef}
              type="date"
              className="library-composer-date-input"
              value={iso}
              onChange={(e) => setIso(e.target.value)}
              aria-label="Custom date"
            />
          </label>
          <button
            type="button"
            className="library-composer-submit"
            onClick={submitIso}
            disabled={!iso}
          >
            Add chip
          </button>
        </div>
        <div className="library-composer-date-relatives" role="group" aria-label="Relative date shortcuts">
          <div className="library-composer-date-relatives-label">Relative</div>
          <div className="library-composer-date-relatives-grid">
            {RELATIVE_DATE_TOKENS.map((tok) => (
              <button
                key={tok}
                type="button"
                className="library-composer-date-relative"
                onClick={() => emit(tok)}
              >
                {tok}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
